import React from 'react';

function RegionalOrganizationText() {
  return (
    <p>
    Relevant organizations are encouraged: to designate, and share information on, points of contact for work relating to the illicit trade in small arms and light weapons; and to report on actions they have taken at the regional and subregional levels that support the implementation of the Programme of Action. The following reports are submitted biennially in time for PoA process meetings/conferences.

    </p>
  );
}

export default RegionalOrganizationText;



// WEBPACK FOOTER //
// ./src/components/RegionalOrganization/RegionalOrganizationText.js